import request from '@/utils/request'
const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {},
	sign: 'dafdsf'
}
// 查询时间段
export function upload ({ data, uploadKey, merchantId }) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/sysfile/upload?uploadKey=${uploadKey}`,
		method: 'post',
		data
	})
}
// 小程序管理上传应用截图
export function uploadImg ({ data, uploadKey, merchantId }) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/sysfile/upload?uploadKey=${uploadKey}`,
		method: 'post',
		data,
		headers: { 'MERCHANT-ID': `${merchantId}` }
	})
}
export function uploadBase64 (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/sysfile/upload/base64',
		method: 'post',
		data: obj
	})
}
